import { HttpLink } from '@apollo/client';
import { authLink, logoutLink } from './auth';

// http transport
const httpLink = new HttpLink({
  // eslint-disable-next-line prefer-template
  uri: API_URL + '?deduplicate=1',
});

export { httpLink };
export default logoutLink.concat(authLink).concat(httpLink);
